// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface IDocumentFileUploadCompletionDto
 */
export interface IDocumentFileUploadCompletionDto {
    /**
     * 
     * @type {string}
     * @memberof IDocumentFileUploadCompletionDto
     */
    object_key: string;
    /**
     * 
     * @type {number}
     * @memberof IDocumentFileUploadCompletionDto
     */
    employee_id?: number;
    /**
     * 
     * @type {string}
     * @memberof IDocumentFileUploadCompletionDto
     */
    file_name: string;
    /**
     * 
     * @type {boolean}
     * @memberof IDocumentFileUploadCompletionDto
     */
    ocr_required?: boolean;
}

/**
 * Check if a given object implements the IDocumentFileUploadCompletionDto interface.
 */
export function instanceOfIDocumentFileUploadCompletionDto(value: object): value is IDocumentFileUploadCompletionDto {
    if (!('object_key' in value) || value['object_key'] === undefined) return false;
    if (!('file_name' in value) || value['file_name'] === undefined) return false;
    return true;
}

export function IDocumentFileUploadCompletionDtoFromJSON(json: any): IDocumentFileUploadCompletionDto {
    return IDocumentFileUploadCompletionDtoFromJSONTyped(json, false);
}

export function IDocumentFileUploadCompletionDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IDocumentFileUploadCompletionDto {
    if (json == null) {
        return json;
    }
    return {
        
        'object_key': json['object_key'],
        'employee_id': json['employee_id'] == null ? undefined : json['employee_id'],
        'file_name': json['file_name'],
        'ocr_required': json['ocr_required'] == null ? undefined : json['ocr_required'],
    };
}

export function IDocumentFileUploadCompletionDtoToJSON(json: any): IDocumentFileUploadCompletionDto {
    return IDocumentFileUploadCompletionDtoToJSONTyped(json, false);
}

export function IDocumentFileUploadCompletionDtoToJSONTyped(value?: IDocumentFileUploadCompletionDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'object_key': value['object_key'],
        'employee_id': value['employee_id'],
        'file_name': value['file_name'],
        'ocr_required': value['ocr_required'],
    };
}

